import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { SidebarHeader, SidebarLinks, SidebarStatus } from './SidebarNav';

type Props = { open: boolean; onOpenChange: (v: boolean) => void };

export function MobileSidebar({ open, onOpenChange }: Props) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-zinc-950/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in md:hidden" />
        <Dialog.Content className="fixed left-0 top-0 bottom-0 z-50 w-64 bg-zinc-950 border-r border-zinc-800 flex flex-col data-[state=open]:animate-in data-[state=open]:slide-in-from-left md:hidden">
          <div className="flex items-center justify-between pr-3">
            <SidebarHeader />
            <Dialog.Title className="sr-only">Navigation</Dialog.Title>
            <Dialog.Close
              className="text-zinc-400 hover:text-zinc-200 p-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
              aria-label="Close navigation"
            >
              <X className="size-4" />
            </Dialog.Close>
          </div>
          <SidebarLinks onNavigate={() => onOpenChange(false)} />
          <div className="mt-auto">
            <SidebarStatus />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
